"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusMessages = exports["default"] = void 0;
var _lodash = require("lodash");
var statusMessages = exports.statusMessages = {
  rejected: 'declined consent',
  pending: 'pending consent'
};
function getPendingReferralStatus(referral) {
  var status = (0, _lodash.get)(referral, 'contact.consent.status');
  switch (status) {
    case 'rejected':
      return statusMessages.rejected;
    case 'pending':
      return statusMessages.pending;
    default:
      return (0, _lodash.get)(referral, 'status', '');
  }
}
var _default = exports["default"] = getPendingReferralStatus;